// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Decco from "../../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_List from "../../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Belt_Option from "../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as DeccoUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as ResponseHandler$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";

function validation_error_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var _type = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "type"), null));
  if (_type.TAG === /* Ok */0) {
    var failure_reason = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "failure_reason"), null));
    if (failure_reason.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                _type: _type._0,
                failure_reason: failure_reason._0
              }
            };
    }
    var e = failure_reason._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".failure_reason" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = _type._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".type" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var _type = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "type"), null));
  if (_type.TAG === /* Ok */0) {
    var message = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "message"), null));
    if (message.TAG === /* Ok */0) {
      var validation_results = Decco.optionFromJson((function (param) {
              return Decco.listFromJson(validation_error_decode, param);
            }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "validation_results"), null));
      if (validation_results.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  _type: _type._0,
                  message: message._0,
                  validation_results: validation_results._0
                }
              };
      }
      var e = validation_results._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".validation_results" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = message._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".message" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = _type._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".type" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function execute(error) {
  var error$1 = error.validation_results;
  return {
          _type: error._type,
          message: error.message,
          validation_results: error$1 !== undefined ? Belt_List.map(error$1, (function (param) {
                    return {
                            _type: param._type,
                            failure_reason: param.failure_reason
                          };
                  })) : /* [] */0
        };
}

function constructErrorMessage(error) {
  var l = error.validation_results;
  if (l) {
    var validation_error = List.hd(l);
    var match = error._type;
    if (match === "core_campaign_not_found") {
      return "The core-campaign for creating this modification does not exist";
    } else {
      return validation_error.failure_reason;
    }
  }
  var m = error.message;
  if (m !== undefined) {
    return m;
  } else {
    return "Something went wrong. Please verify your inputs. and try again";
  }
}

function execute$1(json) {
  var error = execute(DeccoUtils$Catalyst.resolveResult(t_decode(json), "CreateModificationErrorConverter.re"));
  return /* DefaultError */{
          _0: {
            title: {
              TAG: /* UnprocessedEntity */1,
              _0: undefined
            },
            message: constructErrorMessage(error)
          }
        };
}

function execute$2(data) {
  if (typeof data === "number" || data.TAG !== /* UnprocessedEntity */2) {
    return ResponseHandler$Catalyst.DefaultErrorConverter.execute(data);
  } else {
    return execute$1(data._0);
  }
}

export {
  execute$2 as execute,
  
}
/* DeccoUtils-Catalyst Not a pure module */
